import React from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';

// Mui Components
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  TextField,
  Box,
  InputLabel,
  IconButton,
  CircularProgress,
  InputAdornment,
} from '@mui/material';
import OlcButton from '~/components/General/OlcButton';

// Icons
import { DetailsCrossCIcon, ModalClosePlansCIcon } from '~/assets/images';
import { Close as CloseIcon } from '@mui/icons-material';

// Styles
import './styles.scss';

// Yup schema for validation
const campaignSchema = Yup.object().shape({
  campaignName: Yup.string()
    .max(50, 'Campaign Name should be less than or equal to 50 characters')
    .required('Campaign Name is required'),
  description: Yup.string().max(
    250,
    'Campaign Description should be less than or equal to 25 characters'
  ),
});

const SaveDialog = ({
  open,
  onClose,
  campaignName,
  description,
  handleSaveAutomation,
  isLoading,
  isEditMode,
}) => {
  return (
    <Dialog className="saveDialog" open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle className="saveDialogTitle">
        <Typography variant="h6" fontWeight="700" sx={{ fontFamily: 'Inter', color: '#000' }}>
          {isEditMode ? 'Update Campaign' : 'Save Campaign'}
        </Typography>
        <IconButton onClick={onClose} className="closeIcon">
          <img src={DetailsCrossCIcon} alt="close" />
        </IconButton>
      </DialogTitle>
      <Formik
        initialValues={{
          campaignName: campaignName || '',
          description: description || '',
        }}
        validationSchema={campaignSchema}
        onSubmit={(values, { setSubmitting }) => {
          handleSaveAutomation(values);
          setSubmitting(false);
        }}
        enableReinitialize
      >
        {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
          <form onSubmit={handleSubmit}>
            <DialogContent sx={{ padding: 0 }}>
              <Box className="campaignFieldsWrapper">
                <Box className="formFieldWrapper">
                  <InputLabel htmlFor="Campaign Name" className="inputLabel">
                    Campaign Name<span>*</span>
                  </InputLabel>
                  <TextField
                    placeholder="Campaign Name"
                    fullWidth
                    autoComplete="off"
                    name="campaignName"
                    className={`inputField ${
                      errors.campaignName && touched.campaignName ? 'invalid' : ''
                    }`}
                    value={values.campaignName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end" sx={{ width: '16px', marginRight: '8px' }}>
                          {values.campaignName && (
                            <IconButton
                              className="cpClearInputBtn"
                              onClick={() =>
                                handleChange({
                                  target: { name: 'campaignName', value: '' },
                                })
                              }
                              edge="end"
                              sx={{ padding: '4px' }}
                            >
                              <CloseIcon fontSize="small" />
                            </IconButton>
                          )}
                        </InputAdornment>
                      ),
                    }}
                  />
                  {touched.campaignName && errors.campaignName && (
                    <Typography className="errorMessage">{errors.campaignName}</Typography>
                  )}
                </Box>
              </Box>
            </DialogContent>
            <DialogActions className="saveDialogActions">
              <OlcButton
                variant="secondary"
                onClick={onClose}
                sx={{
                  textTransform: 'capitalize',
                  color: '#303030',
                  fontFamily: 'Inter',
                }}
                type="button"
              >
                Cancel
              </OlcButton>
              <OlcButton
                variant="primary"
                disabled={isLoading || isSubmitting}
                type="submit"
                sx={{
                  borderRadius: 1,
                  textTransform: 'capitalize',
                  backgroundColor: '#ed5c2f',
                  fontFamily: 'Inter',
                  fontWeight: 600,
                  '&:hover': {
                    backgroundColor: '#ed5c2f',
                  },
                }}
              >
                {isLoading ? (
                  <CircularProgress
                    sx={{
                      color: '#fff',
                      width: '20px !important',
                      height: '20px !important',
                    }}
                  />
                ) : isEditMode ? (
                  'Update'
                ) : (
                  'Save'
                )}
              </OlcButton>
            </DialogActions>
          </form>
        )}
      </Formik>
    </Dialog>
  );
};

export default SaveDialog;
